import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { AxiosSingleton } from '../../utils/axiosinstance';
import { contendingCampaignsTableColumns } from './tableColumns';

type Props = {
  /** Key of the inventory query, returned by GET /inventory/impressions. */
  impressionsKey: string;
  /** Height of the scrollable table body, e.g. '60vh'. */
  scrollHeight?: string;
};

/**
 * Campaigns contending for the inventory of one inventory query. Used by the
 * Inventory page modal and by the standalone /contending-campaigns page.
 */
export default function ContendingCampaignsTable({ impressionsKey, scrollHeight = '60vh' }: Props) {
  const axios = AxiosSingleton.axiosInstance;
  const [campaigns, setCampaigns] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    let isCurrent = true;
    setIsLoading(true);
    setErrorMessage('');
    axios
      .get('/inventory/contendinglines', { params: { key: impressionsKey } })
      .then((res) => {
        if (isCurrent) setCampaigns(res.data?.data || []);
      })
      .catch((error) => {
        if (!isCurrent) return;
        setCampaigns([]);
        setErrorMessage(
          error.response?.data?.message || 'An error occurred while loading contending campaigns.'
        );
      })
      .finally(() => {
        if (isCurrent) setIsLoading(false);
      });
    return () => {
      isCurrent = false;
    };
  }, [impressionsKey]);

  if (errorMessage) {
    return <div className="contending-campaigns-error">{errorMessage}</div>;
  }

  return (
    <Table
      bordered
      size="small"
      pagination={false}
      loading={isLoading}
      columns={contendingCampaignsTableColumns as any}
      dataSource={campaigns.map((campaign) => ({ ...campaign, key: campaign.id }))}
      locale={{ emptyText: 'No campaigns are contending for this inventory.' }}
      scroll={{ x: 1500, y: scrollHeight }}
    />
  );
}
